import { useQueries } from "@tanstack/react-query";
import { getPartyQueryKey } from "Api/Queries/Party/usePartyQuery";
import { type PartyDto, getPartiesPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const usePartiesQueries = (partyIDs: Array<string>) => {
  const queries = useQueries({
    queries: partyIDs.map((id) => ({
      queryKey: getPartyQueryKey(id),
      queryFn: () =>
        processResponseWithApiProblemDetails(() => getPartiesPublicID(id))(),
    })),
  });

  const isPending = queries.some(({ isPending }) => isPending);
  const data = queries.map(({ data }) => data as PartyDto).filter(Boolean);

  return { data, isPending };
};
